module.exports = __webpack_public_path__ + "img/item.9ce33374.svg";